module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-4.0b1bce76.png";